import { stateAbbrNameMap } from '@mortgage-pos/data'
import { TextValuePair } from '@mortgage-pos/types'

const otherDropdown: TextValuePair = { text: 'Other', value: 'Other' }

export const mapStatesDropdownData = (
  stateAbbreviations: string[]
): TextValuePair[] => {
  const dropdownData: TextValuePair[] = stateAbbreviations
    .map((stateAbbreviation) => ({
      text: stateAbbrNameMap[stateAbbreviation],
      value: stateAbbreviation,
    }))
    .sort((a, b) => a.text.localeCompare(b.text, 'en', { sensitivity: 'base' })) // Sorts by full State Name

  dropdownData.push(otherDropdown) // Adding an "Other" option at the end of the list

  return dropdownData
}
